import { atom } from 'jotai';
import { SourceCurrencyList, TargetCurrencyList } from '../../types';
import { Loadable, LoadableState } from '../../utils';

/**
 * [Standalone currency exchange] Available source currencies for currency exchange
 */
export const sourceCurrenciesAtom = atom<LoadableState<SourceCurrencyList>>(Loadable.uninitialized);

/**
 * [Standalone currency exchange] Available target currencies for the selected source currency
 */
export const targetCurrenciesAtom = atom<LoadableState<TargetCurrencyList>>(Loadable.uninitialized);

/**
 * [Standalone currency exchange] Active source currencies for currency exchange
 */
export const activeSourceCurrenciesAtom = atom<LoadableState<string[]>>(Loadable.uninitialized);
